import { render, staticRenderFns } from "./BillTypeCode.vue?vue&type=template&id=72d96283&"
import script from "./BillTypeCode.vue?vue&type=script&lang=js&"
export * from "./BillTypeCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports